export default __webpack_public_path__ + "static/email-templates-preview-b81d3525cd85635f430ad5efedff2e43.mp4";